import { Box, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import { useSelector } from "react-redux";
import React from "react";

const CustomDocumentContractorTab = () => {
  const { selectedRow } = useSelector((state) => state.myPermitsComponent);
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          mt: 1,
        }}
      >
        <img
          alt="contractor"
          src="/img/website_img/contractor_img.png"
          style={{
            width: "100%",
            maxWidth: "5rem",
            height: "auto",
            borderRadius: "20px",
          }}
        />
        <Typography mt={1} fontWeight="bold">
          {selectedRow?.contractor?.ORGANIZATION?.nameUnparsed}
        </Typography>
        <Typography mt={-0.5} fontWeight="bold">
          {selectedRow?.contractor?.licenseNumber}
        </Typography>
        <Box mt={6}>
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}
          >
            <LocationOnIcon />
            <Typography>{selectedRow?.contractor?.address}</Typography>
          </Box>

          <Box
            sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}
          >
            <EmailIcon />
            <Typography>{selectedRow?.contractor?.email}</Typography>
          </Box>
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}
          >
            <PhoneIcon />
            <Typography>{selectedRow?.contractor?.phone_number}</Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default React.memo(CustomDocumentContractorTab);
